import { memo } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import css from './Menu.sass'
import Item from './Item/Item'

const Menu = memo(({ items, onClickHandlers, isAgent, urlParams }) => (
  <div className={cx(css.root)}>
    {items
      .filter((item) => !item.hidden)
      .map((item, index) => {
        const { link, text, routeMatches, attributes, onClickHandlerName, onClickHandler } = item

        return (
          <Menu.Item
            key={index}
            routeMatches={routeMatches}
            attributes={attributes}
            link={link}
            text={text}
            isAgent={isAgent}
            urlParams={urlParams}
            onClick={onClickHandler || (onClickHandlers && onClickHandlers[onClickHandlerName])}
          />
        )
      })}
  </div>
))

Menu.Item = Item

const { oneOfType, string, arrayOf, bool, shape, object, func } = PropTypes

Menu.propTypes = {
  items: arrayOf(
    shape({
      link: oneOfType([string, func]),
      onClickHandlerName: string,
      text: string,
      routeMatches: oneOfType([bool, func]),
    })
  ),
  onClickHandlers: object,
  isAgent: bool,
  urlParams: object,
}

export { Menu }
